import React, { useState } from 'react';
import './TextSettingsSection.css';

/**
 * 🚀 UNIVERSAL SECTION CONTAINER 2025
 * 
 * Revolutionäres, wiederverwendbares Container-Design für alle Widget-Edit Sektionen.
 * Ersetzt die verschachtelten elegant-input-container mit modernem, flachem Design.
 * 
 * Features:
 * - Sleek Header mit Icon, Titel und Counter
 * - Smooth Toggle-Animation
 * - Glassmorphism Effects
 * - Responsive Design
 * - Universal für alle Widgets verwendbar
 */
function UniversalSectionContainer({ 
    icon = "⚙️",
    title = "Settings",
    count = null,
    children,
    defaultExpanded = false,
    gradient = "default" // default, purple, blue, green, orange
}) {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    const getGradient = () => {
        const gradients = {
            default: "linear-gradient(135deg, var(--blue) 0%, #4a90e2 100%)",
            purple: "linear-gradient(135deg, #8b5cf6 0%, #a855f7 100%)",
            blue: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
            green: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
            orange: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
            red: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
            pink: "linear-gradient(135deg, #ec4899 0%, #db2777 100%)"
        };
        return gradients[gradient] || gradients.default;
    };
    
    return (
        <div className="revolutionary-text-container">
            {/* Sleek Header mit modernem Toggle */}
            <div 
                className={`text-header ${isExpanded ? 'expanded' : ''}`}
                onClick={toggleExpanded}
                style={{
                    background: isExpanded ? getGradient() : "linear-gradient(135deg, #fafbfc 0%, #f8fafc 100%)"
                }}
            >
                <div className="text-header-content">
                    <div className="text-icon">{icon}</div>
                    <div className="text-title">{title}</div>
                    {count !== null && (
                        <div className="text-count">{count}</div>
                    )}
                </div>
                <div className={`text-toggle-arrow ${isExpanded ? 'rotated' : ''}`}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path 
                            d="M4 6L8 10L12 6" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>

            {/* Expanded Content - Flat Design */}
            {isExpanded && (
                <div className="text-content-expanded">
                    {children}
                </div>
            )}
        </div>
    );
}

export default UniversalSectionContainer;
